import React from 'react';
import { withRouter } from 'react-router-dom';
import GoogleMapReact from 'google-map-react';
import { MapMarker } from 'Utils/SvgIcons';
import Marker from 'Utils/Marker';
import service from 'Api/service';
import { history } from 'Components/utils/router/history';
import { isEqual } from 'lodash';
import { connect } from 'react-redux';
import * as actions from 'Actions';

const DEFAULT_ZOOM = 1;
let DEFAULT_CENTER = { lat: 32.7544, lng: -96.822 };

class MapContainer extends React.Component {
  static defaultProps = {
    displayingMap: true,
  };

  state = {
    googleServiceLoaded: false,
    markers: [],
    gpsMarkers: [],
    points: [],
    origin: {},
    destination: {},
    directionsService: null,
    directionsDisplay: null,
    truckRoute: {},
    intervalId: 0,
    routePolyline: null,
  };

  UNSAFE_componentWillMount() {
    if (this.props.truckRoute.stops.length > 0) {
      this.refreshMap(this.props);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.truckRoute.stops.length > 0 &&
      this.props.truckRoute.stops.length !== nextProps.truckRoute.stops.length
    ) {
      this.refreshMap(nextProps);
    } else if (
      nextProps.truckRoute.stops.length > 0 &&
      this.props.truckRoute.stops.length ===
        nextProps.truckRoute.stops.length &&
      this.props.truckRoute.stops.some((stop, index) => {
        return stop.id !== nextProps.truckRoute.stops[index].id;
      })
    ) {
      this.refreshMap(nextProps);
    } else if (
      !isEqual(
        nextProps.truckRoute.routeStart,
        this.props.truckRoute.routeStart
      ) ||
      !isEqual(nextProps.truckRoute.routeEnd, this.props.truckRoute.routeEnd)
    ) {
      this.refreshMap(nextProps);
    }
  }

  componentDidMount() {
    const { business, truckRoute } = this.props;

    if (business.gpsApiConnected && truckRoute) {
      const gpsInterval = setInterval(this._paintGpsMarkers, 5000);

      this.setState((prevState) => {
        return {
          ...prevState,
          intervalId: gpsInterval,
        };
      });
    }
  }

  componentWillUnmount() {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }

  findCoordinates = (rentalTransport) => {
    const { rental } = rentalTransport;
    const type = rentalTransport.transportType;
    // the below array of two null values are used if coordinates are null in any case then gets a error
    //  wherever this method is called, as the call expects return of atleast two array values
    const obj = [null, null];
    if (!rentalTransport.deliveryCoordinates) {
      rentalTransport.deliveryCoordinates = obj;
    }
    if (!rentalTransport.pickupCoordinates) {
      rentalTransport.pickupCoordinates = obj;
    }
    if (type === 'pick_up') {
      if (rental && rental.pickupSameAsDelivery) {
        return rentalTransport.deliveryCoordinates;
      } else {
        return rentalTransport.pickupCoordinates;
      }
    } else {
      return rentalTransport.deliveryCoordinates;
    }
  };

  findAddress = (rentalTransport) => {
    const { rental } = rentalTransport;
    const type = rentalTransport.transportType;
    if (type === 'pick_up') {
      if (rental.pickupSameAsDelivery) {
        return rentalTransport.deliveryAddress;
      } else {
        return rentalTransport.pickupAddress;
      }
    } else {
      return rentalTransport.deliveryAddress;
    }
  };

  refreshMap = (props) => {
    let markers = [];
    const { truckRoute, history } = props;
    const {
      googleServiceLoaded,
      directionsService,
      directionsDisplay,
    } = this.state;
    const originMarker = (
      <Marker
        key='origin'
        type='warehouse'
        lat={truckRoute.routeStart.latitude}
        lng={truckRoute.routeStart.longitude}
        truck={truckRoute.truck}
        text={`*`}
        onClickHandler={(event) => {
          event.preventDefault();
        }}
      />
    );
    markers.push(originMarker);

    let points = [];
    let loc;
    let origin = {
      lat: truckRoute.routeStart.latitude,
      lng: truckRoute.routeStart.longitude,
      address: truckRoute.routeStart.fullStreetAddress,
    };

    let stopNum = 0;
    truckRoute.stops.forEach((stop) => {
      if (stop.stopType === 'custom' && !stop.physicalAddress) {
        return;
      }
      if (
        stop.stopType !== 'custom' &&
        !stop.rentalTransport.deliveryCoordinates
      ) {
        return;
      }
      let marker;
      stopNum++;
      if (stop.stopType === 'custom') {
        loc = {
          lat: stop.physicalAddress.latitude,
          lng: stop.physicalAddress.longitude,
        };
        const overlapped = truckRoute.stops.some((s) => {
          if (s.id !== stop.id) {
            if (s.stopType === 'custom') {
              return (
                loc.lat === s.physicalAddress.latitude &&
                loc.lng === s.physicalAddress.longitude
              );
            } else {
              return (
                loc.lat === this.findCoordinates(s.rentalTransport)[0] &&
                loc.lng === this.findCoordinates(s.rentalTransport)[1]
              );
            }
          } else {
            return false;
          }
        });
        marker = (
          <Marker
            key={stop.id}
            stopId={stop.id}
            truck={truckRoute.truck}
            rentalTransport={stop.rentalTransport}
            type='stop'
            lat={stop.physicalAddress.latitude}
            lng={stop.physicalAddress.longitude}
            text={stopNum}
            onClickHandler={(event) => {
              event.preventDefault();
            }}
            overlapped={overlapped}
          />
        );
      } else {
        loc = {
          lat: this.findCoordinates(stop.rentalTransport)[0],
          lng: this.findCoordinates(stop.rentalTransport)[1],
          address: this.findAddress(stop.rentalTransport),
        };
        const overlapped = truckRoute.stops.some((s) => {
          if (s.id !== stop.id) {
            if (s.stopType === 'custom') {
              return (
                loc.lat === s.physicalAddress.latitude &&
                loc.lng === s.physicalAddress.longitude
              );
            } else {
              return (
                loc.lat === this.findCoordinates(s.rentalTransport)[0] &&
                loc.lng === this.findCoordinates(s.rentalTransport)[1]
              );
            }
          } else {
            return false;
          }
        });
        marker = (
          <Marker
            key={stop.id}
            stopId={stop.id}
            type='route'
            truck={truckRoute.truck}
            transportType={stop.rentalTransport.transportType}
            rentalTransport={stop.rentalTransport}
            lat={this.findCoordinates(stop.rentalTransport)[0]}
            lng={this.findCoordinates(stop.rentalTransport)[1]}
            text={stopNum}
            overlapped={overlapped}
          />
        );
      }
      markers.push(marker);
      points.push(loc);
    });

    let destination = {
      lat: truckRoute.routeEnd.latitude,
      lng: truckRoute.routeEnd.longitude,
      address: truckRoute.routeStart.fullStreetAddress,
    };
    const destinationMarker = (
      <Marker
        type='warehouse'
        key={'destination'}
        lat={truckRoute.routeStart.latitude}
        lng={truckRoute.routeStart.longitude}
        truck={truckRoute.truck}
        text={`*`}
        onClickHandler={(event) => {
          event.preventDefault();
        }}
      />
    );
    markers.push(destinationMarker);

    if (googleServiceLoaded) {
      this.setState(
        {
          points: points,
          origin: origin,
          destination: destination,
          markers,
          truckRoute: truckRoute,
        },
        () => {
          this.calculateAndDisplayRoute(directionsService, directionsDisplay);
        }
      );
    } else {
      this.setState({ points, origin, destination, markers, truckRoute });
    }
    // this.points = [
    //   { lat: Number(32.7544), lng: Number(-96.8220) },
    //   { lat: Number(32.7702), lng: Number(-96.8451) }
    // ];

    // this.origin = { lat: Number(32.7413), lng: Number(-96.8481) };
    // this.destination = { lat: Number(32.7778), lng: Number(-96.8010) };
  };

  onGoogleApiLoaded = ({ map, maps }) => {
    console.info('maps api : onGoogleApiLoaded');

    this._maps = maps;
    this._map = map;
    const { points, truckRoute } = this.state;
    let directionsService = new maps.DirectionsService();
    let directionsDisplay = new maps.DirectionsRenderer({
      polylineOptions: {
        strokeColor: Object(truckRoute.truck).color,
      },
      suppressMarkers: true,
    });

    directionsDisplay.setMap(map);
    if (directionsService && directionsDisplay) {
      if (points.length > 0) {
        this.setState(
          {
            googleServiceLoaded: true,
            directionsService,
            directionsDisplay,
          },
          () => {
            this.calculateAndDisplayRoute(directionsService, directionsDisplay);
          }
        );
      } else {
        this.setState({
          googleServiceLoaded: true,
          directionsService,
          directionsDisplay,
        });
      }
    }
  };

  calculateAndDisplayRoute = (directionsService, directionsDisplay) => {
    const { points, origin, destination } = this.state;
    const { addWaypoints } = this.props;

    var delayCounter = 0;

    const waypoints = points.map((point) => {
      if (point.address) {
        return { location: point.address, stopover: true };
      }
      return { location: new window.google.maps.LatLng(point), stopover: true };
    });

    addWaypoints(waypoints);

    const component = this;
    directionsService.route(
      {
        origin: origin.address,
        destination: destination.address,
        waypoints: waypoints,
        travelMode: 'DRIVING',
      },
      function(response, status) {
        let raise = false;

        if (status === 'OK') {
          directionsDisplay.setDirections(response);
          // Print pages build a static map image from the route's encoded, road-
          // following polyline (see buildStaticMapUrl/render) instead of using a
          // live map — see TD1-7659. `overview_polyline` is a plain encoded string in
          // the current API response; older docs describe it as `{ points: string }`,
          // so accept either shape defensively.
          const overviewPolyline = response.routes?.[0]?.overview_polyline;
          component.setState({
            routePolyline:
              typeof overviewPolyline === 'string'
                ? overviewPolyline
                : overviewPolyline?.points,
          });
          const { setDirections, displayingInfo } = component.props;
          if (displayingInfo) {
            setDirections(response.routes[0]);
          }
          const { onDirectionResponseChange } = component.props;
          if (onDirectionResponseChange) {
            onDirectionResponseChange(response);
          }
        } else if (status === 'OVER_QUERY_LIMIT') {
          console.warn('delaying query to google maps api service');

          setTimeout(function() {
            component.calculateAndDisplayRoute(
              directionsService,
              directionsDisplay
            );
          }, delayCounter * 1000);

          delayCounter++;
        } else {
          let msg = 'Directions request failed due to ' + status;

          if (status === 'ZERO_RESULTS') {
            msg =
              'Directions request failed due to invalid address. Please make sure the address associated with the order is valid.';
          } else {
            raise = true;
          }

          window.alert(msg);
          if (raise) {
            throw msg;
          }
        }
      }
    );
  };

  // Builds a Google Static Maps API URL from the same route data the live map uses —
  // the encoded, road-following polyline from DirectionsService (not a straight line
  // between stops), plus a marker per stop and distinct start/end markers. Static Maps
  // marker labels must be a single alphanumeric character, so stops beyond #9 render
  // unlabeled (the stop order is already listed as text below the map on every print
  // page) — see TD1-7659.
  buildStaticMapUrl = () => {
    const { routePolyline, points, origin, destination, truckRoute } = this.state;
    if (!routePolyline || !origin.lat || !destination.lat) {
      return null;
    }

    const color = ((truckRoute.truck && truckRoute.truck.color) || '#000000').replace(
      '#',
      '0x'
    );

    const params = [
      'size=640x640',
      'scale=2',
      `path=weight:3|color:${color}|enc:${encodeURIComponent(routePolyline)}`,
      `markers=color:green|label:S|${origin.lat},${origin.lng}`,
      `markers=color:red|label:E|${destination.lat},${destination.lng}`,
      ...points.map((point, index) => {
        const parts = [`color:${color}`];
        if (index < 9) {
          parts.push(`label:${index + 1}`);
        }
        parts.push(`${point.lat},${point.lng}`);
        return `markers=${parts.join('|')}`;
      }),
      `key=${import.meta.env.VITE_GMAP_API_KEY}`,
    ];

    return `https://maps.googleapis.com/maps/api/staticmap?${params.join('&')}`;
  };

  _paintGpsMarkers = () => {
    let { truck, rentalTransports } = this.props.truckRoute;

    let gpsTransports = [];
    let gpsStringIds = [];

    rentalTransports &&
      rentalTransports.forEach((rt) => {
        if (truck.gpsDevice) {
          gpsTransports.push({
            truck,
            rt,
          });
          gpsStringIds.push(truck.gpsDevice.gpsDeviceId);
        }
      });

    let gpsQueryString = gpsStringIds.join(',');
    if (gpsStringIds != '') {
      this._fetchGpsCoordinates(gpsQueryString, gpsTransports);
    }
  };

  _fetchGpsCoordinates = (deviceIds, gpsTransports) => {
    const { gpsApiConnected } = this.props.business;
    if (gpsApiConnected) {
      service
        .get(
          import.meta.env.VITE_API_DOMAIN +
            `/api/gps_devices/get_gps_locations`,
          {
            gps_device_ids: deviceIds,
          }
        )
        .then((response) => {
          this._buildMarkers(response.data.data, gpsTransports);
        });
    }
  };

  _buildMarkers = (coordinates, gpsTransports) => {
    const gpsMarkers = coordinates.map((coord) => {
      const gpsTransport = gpsTransports.find(
        (gpsTransport) => gpsTransport.truck.gpsDevice.gpsDeviceId === coord.id
      );

      return (
        <Marker
          id={gpsTransport.truck.id}
          color={
            gpsTransport.truck.color ? gpsTransport.truck.color : '#FF886D'
          }
          type={'truck'}
          transportType={gpsTransport.rt.transportType}
          key={gpsTransport.truck.id}
          truck={gpsTransport.truck}
          lat={coord.lat}
          lng={coord.lng}
          onClickHandler={() => {
            history.push(
              `/operations/routing/map/locations/${gpsTransport.rt.id}`
            );
          }}
        />
      );
    });

    let newGpsMarkers = [];

    gpsMarkers.forEach((marker) => {
      newGpsMarkers.push(marker);
    });

    this.setState({
      gpsMarkers: newGpsMarkers,
    });
  };

  render() {
    const { displayingMap, disableUI } = this.props;
    const { markers, gpsMarkers } = this.state;

    const combinedMarkers = [...markers, ...gpsMarkers];
    const mapOptions = {
      fullscreenControl: false,
      scrollwheel: false,
      ...(disableUI && {
        disableDefaultUI: true,
        keyboardShortcuts: false,
        clickableIcons: false,
      }),
    };

    const googleMapReact = (
      <GoogleMapReact
        bootstrapURLKeys={{ key: import.meta.env.VITE_GMAP_API_KEY }}
        options={mapOptions}
        defaultCenter={DEFAULT_CENTER}
        zoom={DEFAULT_ZOOM}
        yesIWantToUseGoogleMapApiInternals={true}
        onGoogleApiLoaded={this.onGoogleApiLoaded}
      >
        {combinedMarkers}
      </GoogleMapReact>
    );

    // Print pages (disableUI) show a STATIC map image instead of the live map. Google
    // Maps draws into a <canvas> that only repaints when JS notices a resize, and by the
    // time the real print/PDF pipeline settles on its final width, that can differ from
    // anything the JS ever measured (varies by OS/browser print-dialog UI, responsive
    // breakpoints, etc.) — see TD1-7659. A static image has no such dependency; it just
    // displays at whatever size the CSS box ends up being.
    //
    // The live GoogleMapReact must still mount and render visibly long enough to load the
    // Maps SDK and run DirectionsService — that is what produces both the static image URL
    // (buildStaticMapUrl) and the turn-by-turn directions; google-map-react will not
    // initialize a hidden/zero-size container. Once the static image is ready we add the
    // `staticMapReady` class, whose CSS collapses the live map to display:none (it stays
    // mounted, so its map instance and script-load sequencing are never torn down). The
    // live map and the static image are never VISIBLE at the same time: showing both
    // rendered two mismatched maps at once — the live map peeking out from behind the
    // letterboxed square image at a different zoom/center — see TD1-7659. These pages
    // exist only to be printed, so the brief live-map flash before the image appears
    // (on screen) is acceptable.
    const staticMapUrl = disableUI ? this.buildStaticMapUrl() : null;

    return (
      <div className='mapContainer'>
        {displayingMap ? (
          <div className={staticMapUrl ? 'map staticMapReady' : 'map'}>
            {googleMapReact}
            {staticMapUrl && <img src={staticMapUrl} alt='Route map' />}
          </div>
        ) : (
          <div style={{ display: 'none' }}>{googleMapReact}</div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { business } = state.business;

  return { business };
};

export default connect(mapStateToProps, actions)(withRouter(MapContainer));
